document.addEventListener('DOMContentLoaded', function () {

  // === 1. Scroll-reveal animace ===
  var revealTargets = document.querySelectorAll(
    '.card-wrapper, .collection-hero, .banner, .rich-text, .image-with-text__content'
  );

  revealTargets.forEach(function (el) {
    el.classList.add('scroll-reveal');
  });

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  revealTargets.forEach(function (el) {
    observer.observe(el);
  });

  // === 4. Potvrzovací animace při přidání do košíku ===
  var cartIcon = document.querySelector('#cart-icon-bubble, .cart-icon-bubble, [id*="cart-icon"]');
  var cartCount = document.querySelector('.cart-count-bubble');

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.getAttribute('action') && form.getAttribute('action').includes('/cart/add')) {
      setTimeout(function () {
        if (cartIcon) {
          cartIcon.classList.add('cart-bump-animate');
          setTimeout(function () { cartIcon.classList.remove('cart-bump-animate'); }, 500);
        }
        if (cartCount) {
          cartCount.classList.add('cart-bump-animate');
          setTimeout(function () { cartCount.classList.remove('cart-bump-animate'); }, 400);
        }
      }, 300);
    }
  });
});